import {Dialog, PrimaryButton, TextField} from "@fluentui/react";
import React from "react";
interface IExternalMappingProps {
    onAdd: (type: string, id: string) => void;
    onClose: () => void;
    display?: boolean;
}
const ExternalMappingsDialog: React.FC<IExternalMappingProps> = (props) => {
    const [idType, setIdType] = React.useState<string | undefined>('');
    const [id, setId] = React.useState<string | undefined>('');
    React.useEffect(() => {
        if(!props.display){
            setId(undefined);
            setIdType(undefined);
        }
    },[props.display])
    return (
        <Dialog
            hidden={!props.display}
            onDismiss={() => {
                setId(undefined)
                setIdType(undefined)
                props.onClose()
            }}
            dialogContentProps={{
                showCloseButton: true,
                styles: { title: { fontSize: 20 } }
            }}
            modalProps={{ isBlocking: false }}
        >
            <h3>
                Add External ID Mapping
            </h3>
            <TextField label='External ID Type' value={idType} onChange={(event, newValue) => setIdType(newValue)} />
            <TextField
                label='External ID'
                value={id}
                onChange={(event, newValue) => setId(newValue)}
                onKeyDown={(event) => {
                if(event.key === 'Enter' && idType && id){
                    props.onAdd(idType, id)
                }}}/>
            <PrimaryButton
                text='Add'
                disabled={!idType || !id}
                onClick={() => {props.onAdd(idType ?? '', id ?? '')}}
            />
        </Dialog>
    )
}
export default ExternalMappingsDialog;